module.exports = __webpack_public_path__ + "static/media/040.48b04021.jpg";